import config from '../../config';
import { getAuthHeaders, handleResponse, handleNoContentResponse } from './common';

const messageTemplatesApi = {
  listTemplates: async ({ includeInactive = false, sortBy, sortDir } = {}) => {
    const params = new URLSearchParams();
    if (includeInactive) params.append('includeInactive', 'true');
    if (sortBy) params.append('sortBy', sortBy);
    if (sortDir) params.append('sortDir', sortDir);
    const qs = params.toString();
    const res = await fetch(
      `${config.api.url}/messages/templates${qs ? `?${qs}` : ''}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  getTemplate: async (templateReferenceId) => {
    const res = await fetch(
      `${config.api.url}/messages/templates/${templateReferenceId}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  createTemplate: async (payload) => {
    const res = await fetch(
      `${config.api.url}/messages/templates`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },

  updateTemplate: async (templateReferenceId, payload) => {
    const res = await fetch(
      `${config.api.url}/messages/templates/${templateReferenceId}`,
      {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },

  deactivateTemplate: async (templateReferenceId) => {
    const res = await fetch(
      `${config.api.url}/messages/templates/${templateReferenceId}`,
      { method: 'DELETE', headers: getAuthHeaders() }
    );
    return handleNoContentResponse(res);
  },

  restoreTemplate: async (templateReferenceId) => {
    const res = await fetch(
      `${config.api.url}/messages/templates/${templateReferenceId}/restore`,
      { method: 'POST', headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },
};

export default messageTemplatesApi;
